import api, { getParams } from './'

const payrollEndpoints = {
  getPayrollAccounts: () => api.get(`payroll/account`),
}

export default payrollEndpoints